import React, { useState, useEffect, useCallback } from 'react';
import {
  Box,
  Button,
  Stack,
  Typography,
  TextField,
  Dialog,
  DialogActions,
  Grid,
  MenuItem,
  Divider,
  Stepper,
  Step,
  StepLabel,
  InputAdornment,
  Chip,
  Avatar,
  Switch,
  FormControlLabel,
  Fade,
  IconButton,
  Drawer,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormControl,
  InputLabel,
  Select,
} from '@mui/material';
import {
  Add as AddIcon,
  Close as CloseIcon,
  Description,
  Euro,
  EventAvailable,
  AccessTime,
  CheckCircle,
  LocationOnOutlined,
  MapOutlined,
  PublicOutlined,
  InfoOutlined,
  CorporateFareOutlined,
} from '@mui/icons-material';
import axios from 'axios';
import { useAuth } from '../../contexts/AuthContext';
import { toast } from 'react-toastify';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Collapse,
} from '@mui/material';
import SyncIcon from '@mui/icons-material/Sync';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Visibility,
  Edit,
  Delete,
  ExpandMore,
  ExpandLess,
} from '@mui/icons-material';
import ConfirmDialog from '../../components/base/ConfirmDialog';

const steps = [
  { label: 'Prestation', icon: <Description />, desc: 'Détails du service' },
  { label: 'Tarification', icon: <Euro />, desc: 'Prix et accès' },
  {
    label: 'Période de disponibilité',
    icon: <EventAvailable />,
    desc: 'Période de validité',
  },
  { label: ' Horaires', icon: <AccessTime />, desc: 'Créneaux et pauses' },
];

const DAYS_OF_WEEK = [
  'lundi',
  'mardi',
  'mercredi',
  'jeudi',
  'vendredi',
  'samedi',
  'dimanche',
];

const Offres = () => {
  const { user } = useAuth();
  const [offres, setOffres] = useState([]);
  const [categories, setCategories] = useState([]); // État pour stocker la liste
  const [open, setOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('token');
  const [intervenants, setIntervenants] = useState([]);
  const today = new Date().toISOString().split('T')[0];

  const [searchTerm, setSearchTerm] = useState('');
  // pour le liste offres
  const [expandedRow, setExpandedRow] = useState(null);
  const toggleRow = (id) => {
    setExpandedRow(expandedRow === id ? null : id);
  };
  const [formData, setFormData] = useState({
    titre_offre: '',
    description_offre: '',
    type_offre: 'chat',
    duree_offre: 60,
    id_category: '',
    status: true,
    prix_offre: '',
    is_paid_offre: true,
    is_accessible_participant: true,
    date_debut_dispo: '',
    date_fin_dispo: '',
    jours_off: ['samedi', 'dimanche'],
    duree_pause: 15,
    plage_horaire_matin_debut: '09:00',
    plage_horaire_matin_fin: '12:00',
    plage_horaire_aprem_debut: '14:00',
    plage_horaire_aprem_fin: '18:00',
    id_intervenant: '', // ✅ important
    // 🔥 NEW FIELDS
    format_offre: '',
    address_ws: '',
    city_ws: '',
    postal_code_ws: '',
    country_ws: '',
    location_note_ws: '',
    lat_ws: '',
    lng_ws: '',
    is_deplacement_possible: false,
  });

  const [isEditMode, setIsEditMode] = useState(false);
  const handleEditOffre = (offre) => {
    if (!offre || !offre.info_offre) {
      toast.error('Offre invalide ou incomplète');
      return;
    }

    const info = offre.info_offre;

    setSelectedOffre(offre); // 🔥 IMPORTANT pour update

    setFormData({
      titre_offre: info.titre_offre ?? '',
      description_offre: info.description_offre ?? '',
      type_offre: info.type_offre ?? 'chat',
      duree_offre: info.duree_offre ?? 60,
      id_category: offre.id_category ?? '',
      status: Boolean(info.status),
      prix_offre: info.prix_offre ?? '',
      is_paid_offre: Boolean(info.is_paid_offre),
      is_accessible_participant: Boolean(info.is_accessible_participant),

      date_debut_dispo: offre.availability?.[0]?.date_debut?.slice(0, 10) ?? '',
      date_fin_dispo: offre.availability?.[0]?.date_fin?.slice(0, 10) ?? '',

      jours_off: (() => {
        const raw = info.jours_off || [];
        if (Array.isArray(raw)) return raw;
        try {
          return JSON.parse(raw);
        } catch {
          return [];
        }
      })(),

      duree_pause: info.duree_pause ?? 15,

      plage_horaire_matin_debut:
        info.plage_horaire_matin_debut?.slice(0, 5) ?? '09:00',
      plage_horaire_matin_fin:
        info.plage_horaire_matin_fin?.slice(0, 5) ?? '12:00',
      plage_horaire_aprem_debut:
        info.plage_horaire_aprem_debut?.slice(0, 5) ?? '14:00',
      plage_horaire_aprem_fin:
        info.plage_horaire_aprem_fin?.slice(0, 5) ?? '18:00',

      id_intervenant: offre.id_intervenant ?? '',
      // 🔥 NEW SAFE MAPPING
      format_offre: info.format_offre ?? '',
      address_ws: info.address_ws ?? '',
      city_ws: info.city_ws ?? '',
      postal_code_ws: info.postal_code_ws ?? '',
      country_ws: info.country_ws ?? '',
      location_note_ws: info.location_note_ws ?? '',
      lat_ws: info.lat_ws ?? '',
      lng_ws: info.lng_ws ?? '',
      is_deplacement_possible: Boolean(info.is_deplacement_possible ?? false),
    });

    setIsEditMode(true);
    setOpen(true);
    setActiveStep(0);
  };
  // 1. Récupération des catégories via ta route spécifique avec gestion du rôle
  const fetchCategories = useCallback(async () => {
    try {
      // Détermination dynamique du préfixe selon le rôle (3 = intervenant, autre = admin)
      const rolePath = user.role === 3 ? 'intervenant' : 'admin';

      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/${rolePath}/categories/list`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // On s'adapte à ta structure de réponse habituelle (res.data.result)
      setCategories(res.data.result || res.data || []);
    } catch (err) {
      console.error('Erreur catégories:', err);
    }
  }, [user.role, token]); // Ajout de user.role ici
  const fetchOffres = useCallback(async () => {
    try {
      const rolePath = user.role === 3 ? 'intervenant' : 'admin';
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/${rolePath}/offer/g/lo/list_offer`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setOffres(res.data.result || []);
    } catch (err) {
      console.error(err);
    }
  }, [user.role, token]);
  const fetchIntervenants = useCallback(async () => {
    if (user.role === 3) return; // ❌ pas besoin

    try {
      const rolePath = user.role === 3 ? 'intervenant' : 'admin';

      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/${rolePath}/intervenant/l/list_intervenant`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setIntervenants(res.data.result || []);
    } catch (err) {
      console.error('Erreur intervenants:', err);
    }
  }, [user.role, token]);
  const [selectedOffre, setSelectedOffre] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);

  const handleOpenDrawer = (offre) => {
    setSelectedOffre(offre);
    setOpenDrawer(true);
  };

  const handleCloseDrawer = () => {
    setSelectedOffre(null);
    setOpenDrawer(false);
  };

  useEffect(() => {
    fetchOffres();
    fetchCategories();
    fetchIntervenants(); // ✅ ajouté
  }, [fetchOffres, fetchCategories, fetchIntervenants]);

  const isStepValid = () => {
    switch (activeStep) {
      case 0:
        return (
          formData.titre_offre &&
          formData.description_offre &&
          formData.id_category &&
          (user.role === 3 || formData.id_intervenant)
        );
      case 1:
        return formData.prix_offre !== '';
      case 2:
        return formData.date_debut_dispo && formData.date_fin_dispo;
      case 3:
        return (
          formData.plage_horaire_matin_debut && formData.plage_horaire_matin_fin
        );
      default:
        return false;
    }
  };

  const buildPayload = () => ({
    titre_offre: formData.titre_offre,
    description_offre: formData.description_offre,
    type_offre: formData.type_offre,
    duree_offre: Number(formData.duree_offre),
    id_category: formData.id_category,
    status: Boolean(formData.status),
    prix_offre: Number(formData.prix_offre),
    is_paid_offre: Boolean(formData.is_paid_offre),
    is_accessible_participant: Boolean(formData.is_accessible_participant),

    // 🔥 IMPORTANT DISPO (sinon backend crash / CarbonPeriod bug)
    date_debut_dispo: formData.date_debut_dispo,
    date_fin_dispo: formData.date_fin_dispo,

    jours_off: Array.isArray(formData.jours_off) ? formData.jours_off : [],
    duree_pause: Number(formData.duree_pause),

    plage_horaire_matin_debut: formData.plage_horaire_matin_debut,
    plage_horaire_matin_fin: formData.plage_horaire_matin_fin,
    plage_horaire_aprem_debut: formData.plage_horaire_aprem_debut,
    plage_horaire_aprem_fin: formData.plage_horaire_aprem_fin,

    id_intervenant: formData.id_intervenant,
    // 🔥 NEW FIELDS (important cohérence backend)
    format_offre: formData.format_offre,
    address_ws: formData.address_ws,
    city_ws: formData.city_ws,
    postal_code_ws: formData.postal_code_ws,
    country_ws: formData.country_ws,
    location_note_ws: formData.location_note_ws,

    lat_ws: formData.lat_ws,
    lng_ws: formData.lng_ws,
    is_deplacement_possible: Boolean(formData.is_deplacement_possible),
  });
  const handleSubmit = async () => {
    setLoading(true);

    try {
      const rolePath = user.role === 3 ? 'intervenant' : 'admin';
      const targetId = user.role === 3 ? user.id_user : formData.id_intervenant;

      if (isEditMode) {
        // 🔥 UPDATE MODE
        const res = await axios.put(
          `${process.env.REACT_APP_API_URL}/${rolePath}/offer/u/update/availabilty/${selectedOffre.id_offre}`,
          buildPayload(),
          { headers: { Authorization: `Bearer ${token}` } }
        );

        toast.success(res.data?.message || 'Offre mise à jour');
      } else {
        // 🔥 CREATE MODE
        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/${rolePath}/offer/a/add_offer/availabilty/${targetId}`,
          buildPayload(),
          { headers: { Authorization: `Bearer ${token}` } }
        );

        toast.success(res.data?.message || 'Offre créée');
      }

      setOpen(false);
      setActiveStep(0);
      setIsEditMode(false);
      fetchOffres();
    } catch (err) {
      console.log('FULL ERROR =>', err);

      const msg =
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        err?.message ||
        'Erreur inconnue';

      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({
      titre_offre: '',
      description_offre: '',
      type_offre: 'chat',
      duree_offre: 60,
      id_category: '',
      status: true,
      prix_offre: '',
      is_paid_offre: true,
      is_accessible_participant: true,
      date_debut_dispo: '',
      date_fin_dispo: '',
      jours_off: ['samedi', 'dimanche'],
      duree_pause: 15,
      plage_horaire_matin_debut: '09:00',
      plage_horaire_matin_fin: '12:00',
      plage_horaire_aprem_debut: '14:00',
      plage_horaire_aprem_fin: '18:00',
      id_intervenant: '',
      lat_ws: '',
      lng_ws: '',
      format_offre: '',
      address_ws: '',
      city_ws: '',
      postal_code_ws: '',
      country_ws: '',
      location_note_ws: '',
    });

    setSelectedOffre(null);
    setIsEditMode(false);
    setActiveStep(0);
  };

  const inputStyle = {
    '& .MuiOutlinedInput-root': {
      borderRadius: '16px',
      backgroundColor: '#F9FBFF',
      '& fieldset': { border: '1px solid #E2EBF6' },
      '&:hover fieldset': { borderColor: '#4318FF' },
      '&.Mui-focused fieldset': { borderWidth: '2px', borderColor: '#4318FF' },
    },
    mb: 3,
  };
  const toggleJourOff = (day) => {
    setFormData((prev) => ({
      ...prev,
      jours_off: prev.jours_off.includes(day)
        ? prev.jours_off.filter((d) => d !== day)
        : [...prev.jours_off, day],
    }));
  };

  const [openConfirm, setOpenConfirm] = useState(false);
  const handleDeleteClick = (offre) => {
    setSelectedOffre(offre);
    setOpenConfirm(true);
  };
  const handleDeleteOffre = async () => {
    if (!selectedOffre) return;

    try {
      const rolePath = user.role === 3 ? 'intervenant' : 'admin';

      const res = await axios.delete(
        `${process.env.REACT_APP_API_URL}/${rolePath}/offer/d/delete/availabilty/${selectedOffre.id_offre}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      toast.success(res.data?.message || 'Offre supprimée');

      setOpenConfirm(false);
      setSelectedOffre(null);

      fetchOffres();
    } catch (err) {
      const msg =
        err?.response?.data?.message || err?.message || 'Erreur suppression';

      toast.error(msg);
    }
  };

  const updateSlotStatus = async (slotId, newStatus) => {
    try {
      const rolePath = user.role === 3 ? 'intervenant' : 'admin';

      const url = `${process.env.REACT_APP_API_URL}/${rolePath}/offer/u/slot/status/${slotId}`;

      await axios.put(
        url,
        { status: newStatus },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
          },
        }
      );

      setOffres((prev) =>
        prev.map((o) => ({
          ...o,
          availability: o.availability.map((a) => ({
            ...a,
            reserved_slots: a.reserved_slots.map((s) =>
              s.id_reserved_slot === slotId ? { ...s, status: newStatus } : s
            ),
          })),
        }))
      );

      toast.success('Status mis à jour');
    } catch (err) {
      console.log('API ERROR =>', err?.response?.data || err.message);

      toast.error(err?.response?.data?.message || 'Erreur update slot');
    }
  };

  const syncOfferWithGoogle = async (offre) => {
    try {
      const rolePath = user.role === 3 ? 'intervenant' : 'admin';

      toast.info('Synchronisation en cours...', { autoClose: 2000 });

      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/${rolePath}/google-calendar/sync-by-offer/${offre.id_offre}`,
        {
          params:
            user.role !== 3 ? { id_intervenant: offre.id_intervenant } : {},
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const conflicts = res.data?.result || [];

      if (conflicts.length > 0) {
        toast.warning(
          `⚠️ ${conflicts.length} créneau(x) bloqué(s) par Google Calendar`
        );
      } else {
        toast.success('✅ Aucun conflit détecté');
      }

      fetchOffres(); // 🔄 Rafraîchir les slots mis à jour
    } catch (err) {
      const msg =
        err?.response?.data?.message || 'Erreur synchronisation Google';
      toast.error(msg);
    }
  };
  const getSlotStyle = (status) => {
    switch (status) {
      case 'available':
        return {
          border: '#10B981',
          dot: '#10B981',
          bg: '#DCFCE7',
          text: '#047857',
        };

      case 'reserved':
        return {
          border: '#3B82F6',
          dot: '#3B82F6',
          bg: '#DBEAFE',
          text: '#1D4ED8',
        };

      case 'blocked':
        return {
          border: '#F59E0B',
          dot: '#F59E0B',
          bg: '#FEF3C7',
          text: '#B45309',
        };

      case 'cancelled':
        return {
          border: '#EF4444',
          dot: '#EF4444',
          bg: '#FEE2E2',
          text: '#B91C1C',
        };

      default:
        return {
          border: '#CBD5E1',
          dot: '#94A3B8',
          bg: '#F1F5F9',
          text: '#334155',
        };
    }
  };

  return (
    <Box sx={{ p: { xs: 2, md: 5 }, bgcolor: '#F4F7FE', minHeight: '100vh' }}>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        justifyContent="space-between"
        alignItems={{ xs: 'flex-start', md: 'center' }}
        gap={3}
        mb={6}
      >
        <Box>
          <Typography
            variant="h3"
            fontWeight="800"
            color="#1B2559"
            letterSpacing="-1px"
          >
            Liste des consultations
          </Typography>
          <Typography variant="body1" color="#A3AED0">
            Pilotez vos prestations professionnelles en temps réel.
          </Typography>
        </Box>

        {/* BARRE DE RECHERCHE ET BOUTON AJOUTER */}
        <Stack
          direction="row"
          gap={2}
          width={{ xs: '100%', md: 'auto' }}
          alignItems="center"
        >
          <TextField
            placeholder="Rechercher par titre, intervenant..."
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{
              width: { xs: '100%', md: '300px' },
              '& .MuiOutlinedInput-root': {
                borderRadius: '12px',
                backgroundColor: '#FFFFFF',
                '& fieldset': { border: '1px solid #E2EBF6' },
                '&:hover fieldset': { borderColor: '#4318FF' },
                '&.Mui-focused fieldset': {
                  borderWidth: '2px',
                  borderColor: '#4318FF',
                },
              },
            }}
          />

          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => {
              resetForm();
              setOpen(true);
            }}
            sx={{
              bgcolor: '#4318FF',
              borderRadius: '18px',
              px: 4,
              py: 1.8,
              fontWeight: '800',
              textTransform: 'none',
              fontSize: '1rem',
              whiteSpace: 'nowrap',
              boxShadow: '0px 10px 25px rgba(67, 24, 255, 0.3)',
            }}
          >
            Créer une consultation
          </Button>
        </Stack>
      </Stack>

      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          borderRadius: '16px',
          border: '1px solid',
          borderColor: 'divider',
          overflow: 'hidden',
          mt: 4,
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
        }}
      >
        <Table>
          <TableHead sx={{ bgcolor: '#F8FAFC' }}>
            <TableRow>
              <TableCell
                sx={{
                  fontWeight: 700,
                  color: '#64748b',
                  textTransform: 'uppercase',
                  fontSize: '0.75rem',
                  py: 2,
                }}
              >
                Titre
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 700,
                  color: '#64748b',
                  textTransform: 'uppercase',
                  fontSize: '0.75rem',
                }}
              >
                Intervenant
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 700,
                  color: '#64748b',
                  textTransform: 'uppercase',
                  fontSize: '0.75rem',
                }}
              >
                Description
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 700,
                  color: '#64748b',
                  textTransform: 'uppercase',
                  fontSize: '0.75rem',
                }}
              >
                Prix
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: 700,
                  color: '#64748b',
                  textTransform: 'uppercase',
                  fontSize: '0.75rem',
                }}
              >
                Statut
              </TableCell>
              <TableCell
                align="right"
                sx={{
                  fontWeight: 700,
                  color: '#64748b',
                  textTransform: 'uppercase',
                  fontSize: '0.75rem',
                }}
              >
                Actions
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {offres
              .filter((offre) => {
                const titre =
                  offre.info_offre?.titre_offre?.toLowerCase() || '';
                const nomIntervenant =
                  offre.intervenant?.nom_user?.toLowerCase() || '';
                const prenomIntervenant =
                  offre.intervenant?.prenom_user?.toLowerCase() || '';
                const recherche = searchTerm.toLowerCase();

                // Vérifie si le terme recherché est dans le titre, le nom ou le prénom
                return (
                  titre.includes(recherche) ||
                  nomIntervenant.includes(recherche) ||
                  prenomIntervenant.includes(recherche)
                );
              })
              .map((offre) => {
                const info = offre.info_offre;
                const isExpanded = expandedRow === offre.id_offre;

                return (
                  <React.Fragment key={offre.id_offre}>
                    {/* ROW PRINCIPALE */}
                    <TableRow
                      hover
                      sx={{
                        '& > *': { borderBottom: 'unset !important' },
                        bgcolor: isExpanded
                          ? 'rgba(67, 24, 255, 0.02)'
                          : 'inherit',
                        transition: 'background-color 0.2s ease',
                      }}
                    >
                      <TableCell sx={{ fontWeight: 600, color: '#1B2559' }}>
                        <Box display="flex" alignItems="center" gap={1}>
                          <IconButton
                            size="small"
                            onClick={() => toggleRow(offre.id_offre)}
                            sx={{
                              color: '#4318FF',
                              bgcolor: isExpanded ? '#F4F7FE' : 'transparent',
                            }}
                          >
                            {isExpanded ? <ExpandLess /> : <ExpandMore />}
                          </IconButton>
                          {info?.titre_offre}
                        </Box>
                      </TableCell>

                      <TableCell sx={{ color: '#4A5568' }}>
                        <Box display="flex" flexDirection="column">
                          <Typography variant="body2" fontWeight={500}>
                            {offre.intervenant?.nom_user}{' '}
                            {offre.intervenant?.prenom_user}
                          </Typography>
                        </Box>
                      </TableCell>

                      <TableCell>
                        <Chip
                          label={
                            <Box
                              component="span"
                              sx={{
                                display: 'block',
                                maxWidth: '150px', // Ajustez la largeur selon vos besoins
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {info?.description_offre}
                            </Box>
                          }
                          variant="outlined"
                          size="small"
                          sx={{
                            borderRadius: '6px',
                            fontWeight: 500,
                            borderColor: '#E2E8F0',
                            height: 'auto', // Permet au conteneur de s'adapter si besoin
                          }}
                        />
                      </TableCell>

                      <TableCell sx={{ fontWeight: 700, color: '#1B2559' }}>
                        {info?.prix_offre} €
                      </TableCell>

                      <TableCell>
                        <Chip
                          label={info?.status ? 'Actif' : 'Inactif'}
                          sx={{
                            fontWeight: 700,
                            borderRadius: '8px',
                            bgcolor: info?.status ? '#E6FFFA' : '#F7FAFC',
                            color: info?.status ? '#047857' : '#718096',
                          }}
                          size="small"
                        />
                      </TableCell>

                      {/* ACTIONS */}
                      <TableCell align="right">
                        <Box display="flex" justifyContent="flex-end" gap={0.5}>
                          <IconButton
                            size="small"
                            sx={{ color: '#A3AED0' }}
                            onClick={() => handleOpenDrawer(offre)}
                          >
                            <Visibility fontSize="small" />
                          </IconButton>
                          <IconButton
                            size="small"
                            sx={{ color: '#A3AED0' }}
                            onClick={() => handleEditOffre(offre)}
                          >
                            <Edit fontSize="small" />
                          </IconButton>{' '}
                          {/* 🔥 NOUVEAU BOUTON SYNC GOOGLE */}
                          <IconButton
                            size="small"
                            onClick={() => syncOfferWithGoogle(offre)}
                            sx={{
                              color: '#4285F4', // Bleu Google
                              '&:hover': {
                                bgcolor: '#EFF6FF',
                                transform: 'rotate(180deg)',
                                transition: 'transform 0.4s ease',
                              },
                            }}
                            title="Synchroniser avec Google Calendar"
                          >
                            <SyncIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            size="small"
                            color="error"
                            sx={{ opacity: 0.8 }}
                            onClick={() => handleDeleteClick(offre)}
                          >
                            <Delete fontSize="small" />
                          </IconButton>
                        </Box>
                      </TableCell>
                    </TableRow>

                    {/* ROW EXPAND */}
                    <TableRow>
                      <TableCell
                        colSpan={6}
                        sx={{
                          p: 0,
                          borderBottom: isExpanded
                            ? '1px solid #E2E8F0'
                            : 'none',
                        }}
                      >
                        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                          <Box
                            sx={{
                              p: 0,
                              bgcolor: '#FFFFFF',
                              borderTop: '1px solid #F1F5F9',
                              maxHeight: '500px',
                              overflowY: 'auto',
                              '&::-webkit-scrollbar': { width: '5px' },
                              '&::-webkit-scrollbar-thumb': {
                                bgcolor: '#D1FAE5',
                                borderRadius: '10px',
                              },
                              '&:hover::-webkit-scrollbar-thumb': {
                                bgcolor: '#10B981',
                              },
                            }}
                          >
                            {/* Header Interne Fixe */}
                            <Box
                              sx={{
                                p: 3,
                                pb: 2,
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                position: 'sticky',
                                top: 0,
                                bgcolor: 'rgba(255, 255, 255, 0.95)',
                                backdropFilter: 'blur(8px)',
                                zIndex: 10,
                                borderBottom: '1px solid #F1F5F9',
                              }}
                            >
                              <Box>
                                <Typography
                                  variant="subtitle1"
                                  sx={{ color: '#064E3B', fontWeight: 800 }}
                                >
                                  Planning des Disponibilités
                                </Typography>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                >
                                  Gestion des créneaux réservés sur l'année en
                                  cours
                                </Typography>
                              </Box>
                              <Chip
                                label={`${offre.availability?.length || 0} Périodes actives`}
                                size="small"
                                sx={{
                                  fontWeight: 700,
                                  bgcolor: '#ECFDF5',
                                  color: '#047857',
                                  border: '1px solid #D1FAE5',
                                }}
                              />
                            </Box>

                            <Box sx={{ p: 3 }}>
                              {offre.availability?.map((avail) => (
                                <Box key={avail.id_dispo} sx={{ mb: 5 }}>
                                  {/* Badge de la période */}
                                  <Box sx={{ mb: 3 }}>
                                    <Typography
                                      variant="overline"
                                      sx={{
                                        color: '#10B981',
                                        fontWeight: 900,
                                        letterSpacing: 1.2,
                                      }}
                                    >
                                      {avail.titre_dispo}
                                    </Typography>
                                    <Typography
                                      variant="h6"
                                      sx={{
                                        color: '#1E293B',
                                        fontWeight: 700,
                                        mt: -0.5,
                                      }}
                                    >
                                      {new Date(
                                        avail.date_debut
                                      ).toLocaleDateString('fr-FR', {
                                        month: 'long',
                                        year: 'numeric',
                                      })}
                                    </Typography>
                                  </Box>

                                  {/* Grille de Slots */}
                                  <Box
                                    sx={{
                                      display: 'grid',
                                      gridTemplateColumns:
                                        'repeat(auto-fill, minmax(220px, 1fr))', // Ajusté un poil plus large pour le texte Google
                                      gap: 2,
                                    }}
                                  >
                                    {avail.reserved_slots?.map((slot) => {
                                      const style = getSlotStyle(slot.status);

                                      return (
                                        <Box
                                          key={slot.id_reserved_slot}
                                          sx={{
                                            p: 2,
                                            borderRadius: '16px',
                                            border: `1px solid ${style.border}`,
                                            bgcolor: '#F8FAFC',
                                            transition:
                                              'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                            cursor: 'default',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'between',
                                            '&:hover': {
                                              bgcolor: '#FFFFFF',
                                              borderColor: style.border,
                                              boxShadow:
                                                '0 10px 25px -5px rgba(0,0,0,0.08)',
                                              transform: 'translateY(-4px)',
                                            },
                                          }}
                                        >
                                          {/* HEADER DATE */}
                                          <Box
                                            display="flex"
                                            alignItems="center"
                                            gap={1.5}
                                          >
                                            <Box
                                              sx={{
                                                width: 8,
                                                height: 8,
                                                borderRadius: '50%',
                                                bgcolor: style.dot,
                                              }}
                                            />
                                            <Typography
                                              variant="body2"
                                              fontWeight="800"
                                              color="#1E293B"
                                            >
                                              {new Date(
                                                slot.start_time
                                              ).toLocaleDateString('fr-FR', {
                                                weekday: 'short',
                                                day: 'numeric',
                                                month: 'short',
                                              })}
                                            </Typography>
                                          </Box>

                                          <Divider
                                            sx={{ my: 1.5, opacity: 0.5 }}
                                          />

                                          {/* TIME + STATUS */}
                                          <Box
                                            display="flex"
                                            justifyContent="space-between"
                                            alignItems="center"
                                            sx={{
                                              mb: slot.blocked_by_google
                                                ? 1.5
                                                : 0,
                                            }} // Marge dynamique si note Google présente
                                          >
                                            <Typography
                                              variant="body2"
                                              sx={{
                                                fontWeight: 900,
                                                color: style.text,
                                                bgcolor: style.bg,
                                                px: 1,
                                                py: 0.2,
                                                borderRadius: '6px',
                                              }}
                                            >
                                              {slot.start_time.slice(11, 16)} —{' '}
                                              {slot.end_time.slice(11, 16)}
                                            </Typography>

                                            {/* STATUS SELECT */}
                                            <select
                                              value={slot.status}
                                              onChange={(e) =>
                                                updateSlotStatus(
                                                  slot.id_reserved_slot,
                                                  e.target.value
                                                )
                                              }
                                              style={{
                                                border: '1px solid #E2E8F0',
                                                borderRadius: 6,
                                                padding: '4px 8px',
                                                fontSize: 12,
                                                outline: 'none',
                                                cursor: 'pointer',
                                              }}
                                            >
                                              <option value="available">
                                                Disponible
                                              </option>
                                              <option value="reserved">
                                                Réservé
                                              </option>
                                              <option value="blocked">
                                                Bloqué
                                              </option>
                                              <option value="cancelled">
                                                Annulé
                                              </option>
                                            </select>
                                          </Box>

                                          {/* 🔥 NOTE DE SYNCHRONISATION GOOGLE CALENDAR */}
                                          {slot.blocked_by_google &&
                                            slot.google_event_summary && (
                                              <Box
                                                sx={{
                                                  mt: 'auto', // Pousse la note vers le bas du composant
                                                  p: 1,
                                                  borderRadius: '8px',
                                                  bgcolor: '#EFF6FF', // Couleur bleue douce "Google"
                                                  border: '1px solid #BFDBFE',
                                                  display: 'flex',
                                                  flexDirection: 'column',
                                                  gap: 0.2,
                                                }}
                                              >
                                                <Typography
                                                  variant="caption"
                                                  sx={{
                                                    color: '#1E40AF',
                                                    fontWeight: 800,
                                                    fontSize: '10px',
                                                    textTransform: 'uppercase',
                                                    letterSpacing: '0.5px',
                                                  }}
                                                >
                                                  Google Calendar
                                                </Typography>
                                                <Typography
                                                  variant="caption"
                                                  sx={{
                                                    color: '#1E293B',
                                                    fontWeight: 600,
                                                    fontSize: '11px',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                  }}
                                                  title={
                                                    slot.google_event_summary
                                                  } // Tooltip natif au survol
                                                >
                                                  {slot.google_event_summary}
                                                </Typography>
                                              </Box>
                                            )}
                                        </Box>
                                      );
                                    })}
                                  </Box>
                                </Box>
                              ))}
                            </Box>
                          </Box>
                        </Collapse>
                      </TableCell>
                    </TableRow>
                  </React.Fragment>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>

      <ConfirmDialog
        open={openConfirm}
        title="Suppression"
        description="Confirmer la suppression de cette offre ?"
        onCancel={() => {
          setOpenConfirm(false);
          setSelectedOffre(null);
        }}
        onConfirm={handleDeleteOffre}
      />
      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={handleCloseDrawer}
        sx={{ zIndex: 3000 }}
        PaperProps={{
          sx: {
            width: { xs: '100%', sm: 500 },
            p: 3,
            bgcolor: '#FFFFFF', // Fond du panneau en blanc
            borderLeft: '1px solid #E5E7EB',
          },
        }}
      >
        {selectedOffre && (
          <Box
            sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}
          >
            {/* --- HEADER --- */}
            <Box
              sx={{ p: 3, bgcolor: '#FFF', borderBottom: '1px solid #F1F5F9' }}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="flex-start"
              >
                <Box>
                  <Typography
                    variant="caption"
                    sx={{
                      color: '#4318FF',
                      fontWeight: 800,
                      letterSpacing: 1,
                    }}
                  >
                    OFFRE DÉTAILLÉE
                  </Typography>
                  <Typography
                    variant="h4"
                    sx={{ fontWeight: 800, color: '#1B2559', mt: 0.5 }}
                  >
                    {selectedOffre.info_offre?.titre_offre}
                  </Typography>
                </Box>
                <IconButton
                  onClick={handleCloseDrawer}
                  sx={{ bgcolor: '#F4F7FE' }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Stack>

              <Stack direction="row" spacing={1} mt={2}>
                <Chip
                  label={
                    selectedOffre.info_offre?.status
                      ? 'Opérationnel'
                      : 'Suspendu'
                  }
                  sx={{
                    bgcolor: selectedOffre.info_offre?.status
                      ? '#05FFB01A'
                      : '#FF5B5B1A',
                    color: selectedOffre.info_offre?.status
                      ? '#05CD99'
                      : '#EE5D50',
                    fontWeight: 700,
                    borderRadius: '8px',
                  }}
                />
                <Chip
                  label={selectedOffre.info_offre?.type_offre.replace('_', ' ')}
                  variant="outlined"
                  sx={{
                    textTransform: 'capitalize',
                    fontWeight: 600,
                    color: '#A3AED0',
                  }}
                />
              </Stack>
            </Box>

            {/* --- CONTENT --- */}
            <Box sx={{ p: 3, overflowY: 'auto', flexGrow: 1 }}>
              {/* SECTION : INTERVENANT (Design Premium) */}
              <Paper
                elevation={0}
                sx={{
                  p: 2,
                  borderRadius: 4,
                  bgcolor: '#FFF',
                  border: '1px solid #E2E8F0',
                  mb: 3,
                }}
              >
                <Stack direction="row" spacing={2} alignItems="center">
                  <Avatar
                    src={`${process.env.REACT_APP_API_URL}/storage/workshop/${selectedOffre.intervenant?.photo_user}`}
                    sx={{
                      width: 64,
                      height: 64,
                      borderRadius: 3,
                      border: '2px solid #F4F7FE',
                    }}
                  />
                  <Box>
                    <Typography
                      variant="subtitle1"
                      fontWeight={800}
                      color="#1B2559"
                    >
                      {selectedOffre.intervenant?.prenom_user}{' '}
                      {selectedOffre.intervenant?.nom_user}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: '#4318FF',
                        fontWeight: 600,
                        fontSize: '0.8rem',
                      }}
                    >
                      {selectedOffre.intervenant?.title_user}
                    </Typography>
                    <Typography variant="caption" color="#A3AED0">
                      {selectedOffre.intervenant?.email_user}
                    </Typography>
                  </Box>
                </Stack>
                <Divider sx={{ my: 1.5, borderStyle: 'dashed' }} />
                <Typography
                  variant="body2"
                  sx={{
                    fontStyle: 'italic',
                    color: '#707EAE',
                    fontSize: '0.85rem',
                  }}
                >
                  "
                  {selectedOffre.intervenant?.description_user?.substring(
                    0,
                    150
                  )}
                  ..."
                </Typography>
              </Paper>

              {/* SECTION : CONFIGURATION HORAIRE */}
              <Typography
                variant="subtitle2"
                sx={{
                  mb: 1.5,
                  fontWeight: 700,
                  color: '#1B2559',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                }}
              >
                ⚙️ Paramètres de session
              </Typography>
              <Grid container spacing={2} mb={3}>
                {[
                  {
                    label: 'Prix Séance',
                    val: `${selectedOffre.info_offre?.prix_offre}€`,
                    sub: 'Paiement activé',
                  },
                  {
                    label: 'Durée',
                    val: `${selectedOffre.info_offre?.duree_offre} min`,
                    sub: `Pause: ${selectedOffre.info_offre?.duree_pause}m`,
                  },
                  {
                    label: 'Matin',
                    val: `${selectedOffre.info_offre?.plage_horaire_matin_debut.substring(0, 5)} - ${selectedOffre.info_offre?.plage_horaire_matin_fin.substring(0, 5)}`,
                    sub: 'Créneaux AM',
                  },
                  {
                    label: 'Après-midi',
                    val: `${selectedOffre.info_offre?.plage_horaire_aprem_debut.substring(0, 5)} - ${selectedOffre.info_offre?.plage_horaire_aprem_fin.substring(0, 5)}`,
                    sub: 'Créneaux PM',
                  },
                ].map((item, idx) => (
                  <Grid item xs={6} key={idx}>
                    <Box
                      sx={{
                        p: 2,
                        bgcolor: '#FFF',
                        borderRadius: 3,
                        border: '1px solid #E2E8F0',
                      }}
                    >
                      <Typography
                        variant="caption"
                        color="#A3AED0"
                        fontWeight={600}
                      >
                        {item.label}
                      </Typography>
                      <Typography
                        variant="body1"
                        fontWeight={800}
                        color="#1B2559"
                      >
                        {item.val}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '0.65rem',
                          color: '#4318FF',
                          fontWeight: 700,
                        }}
                      >
                        {item.sub}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>

              {/* SECTION : JOURS DE REPOS */}
              <Box
                sx={{
                  mb: 3,
                  p: 2,
                  bgcolor: '#FEE2E2',
                  borderRadius: 3,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ color: '#991B1B', fontWeight: 700 }}
                >
                  Jours de fermeture :
                </Typography>
                <Stack direction="row" spacing={1}>
                  {JSON.parse(selectedOffre.info_offre?.jours_off || '[]').map(
                    (day) => (
                      <Chip
                        key={day}
                        label={day}
                        size="small"
                        sx={{
                          bgcolor: '#FFF',
                          color: '#991B1B',
                          fontWeight: 700,
                          fontSize: '0.7rem',
                        }}
                      />
                    )
                  )}
                </Stack>
              </Box>
              <Paper
                elevation={0}
                sx={{
                  p: 3,
                  borderRadius: 4,
                  border: '1px solid #E2E8F0',
                  background:
                    'linear-gradient(135deg, #F9FBFF 0%, #FFFFFF 100%)',
                  mb: 3,
                  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.03)',
                }}
              >
                <Stack direction="row" alignItems="center" spacing={1.5} mb={1}>
                  <Box
                    sx={{
                      bgcolor: '#E0E7FF',
                      p: 1,
                      borderRadius: 2,
                      display: 'flex',
                    }}
                  >
                    <CorporateFareOutlined
                      sx={{ color: '#4318FF', fontSize: 20 }}
                    />
                  </Box>
                  <Typography
                    variant="caption"
                    color="#A3AED0"
                    fontWeight={700}
                    sx={{ letterSpacing: 1 }}
                  >
                    FORMAT DE L’OFFRE
                  </Typography>
                </Stack>

                <Typography
                  variant="h6"
                  fontWeight={800}
                  color="#1B2559"
                  sx={{ pl: 5.5 }}
                >
                  {selectedOffre.info_offre?.format_offre?.toUpperCase() ||
                    'NON DÉFINI'}
                </Typography>
              </Paper>

              {['presentiel', 'hybride'].includes(
                selectedOffre.info_offre?.format_offre
              ) && (
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    border: '1px solid #E2E8F0',
                    bgcolor: '#FFFFFF',
                  }}
                >
                  <Stack direction="row" alignItems="center" spacing={1} mb={3}>
                    <LocationOnOutlined sx={{ color: '#1B2559' }} />
                    <Typography
                      variant="subtitle1"
                      fontWeight={800}
                      color="#1B2559"
                    >
                      Localisation
                    </Typography>
                  </Stack>

                  <Grid container spacing={3}>
                    {/* Adresse Principale */}
                    <Grid item xs={12}>
                      <Typography
                        variant="caption"
                        color="#A3AED0"
                        fontWeight={600}
                      >
                        ADRESSE
                      </Typography>
                      <Typography
                        variant="body1"
                        color="#1B2559"
                        fontWeight={500}
                      >
                        {selectedOffre.info_offre?.address_ws || '—'}
                      </Typography>
                    </Grid>

                    {/* Ville et Code Postal */}
                    <Grid item xs={6}>
                      <Typography
                        variant="caption"
                        color="#A3AED0"
                        fontWeight={600}
                      >
                        VILLE
                      </Typography>
                      <Typography
                        variant="body2"
                        color="#4A5568"
                        fontWeight={500}
                      >
                        {selectedOffre.info_offre?.city_ws || '—'}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography
                        variant="caption"
                        color="#A3AED0"
                        fontWeight={600}
                      >
                        CODE POSTAL
                      </Typography>
                      <Typography
                        variant="body2"
                        color="#4A5568"
                        fontWeight={500}
                      >
                        {selectedOffre.info_offre?.postal_code_ws || '—'}
                      </Typography>
                    </Grid>

                    {/* Coordonnées GPS - Look plus technique */}
                    <Grid item xs={12}>
                      <Box
                        sx={{
                          p: 1.5,
                          bgcolor: '#F4F7FE',
                          borderRadius: 2,
                          display: 'flex',
                          gap: 3,
                        }}
                      >
                        <Stack direction="row" spacing={1} alignItems="center">
                          <MapOutlined
                            sx={{ fontSize: 16, color: '#A3AED0' }}
                          />
                          <Typography
                            variant="caption"
                            sx={{ color: '#4A5568' }}
                          >
                            <b>Lat:</b>{' '}
                            {selectedOffre.info_offre?.lat_ws || '0.0'}
                          </Typography>
                        </Stack>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography
                            variant="caption"
                            sx={{ color: '#4A5568' }}
                          >
                            <b>Long:</b>{' '}
                            {selectedOffre.info_offre?.lng_ws || '0.0'}
                          </Typography>
                        </Stack>
                      </Box>
                    </Grid>

                    {/* Note si présente */}
                    {selectedOffre.info_offre?.location_note_ws && (
                      <Grid item xs={12}>
                        <Divider sx={{ my: 1, borderStyle: 'dashed' }} />
                        <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                          <InfoOutlined
                            sx={{ fontSize: 16, color: '#A3AED0', mt: 0.3 }}
                          />
                          <Typography
                            variant="body2"
                            color="#718096"
                            fontStyle="italic"
                          >
                            {selectedOffre.info_offre.location_note_ws}
                          </Typography>
                        </Stack>
                      </Grid>
                    )}
                  </Grid>
                </Paper>
              )}
              {/* SECTION : CALENDRIER ET RÉSERVATIONS */}
              {/* SECTION : CALENDRIER ET RÉSERVATIONS */}
              <Typography
                variant="subtitle2"
                sx={{ mb: 1.5, fontWeight: 700, color: '#1B2559' }}
              >
                📅 Planning des réservations
              </Typography>

              {selectedOffre.availability?.map((a) => (
                <Box key={a.id_dispo} sx={{ mb: 2 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      borderRadius: 3,
                      border: '1px solid #E2E8F0',
                      overflow: 'hidden',
                    }}
                  >
                    {/* Infos principales (toujours visibles) */}
                    <Box sx={{ p: 2, bgcolor: '#FFF' }}>
                      <Typography variant="body2" fontWeight={800}>
                        {a.titre_dispo}
                      </Typography>
                      <Typography variant="caption" color="#A3AED0">
                        Période du {new Date(a.date_debut).toLocaleDateString()}{' '}
                        au {new Date(a.date_fin).toLocaleDateString()}
                      </Typography>
                    </Box>

                    {/* Accordéon pour les slots (cachés par défaut) */}
                    <Accordion
                      elevation={0}
                      disableGutters
                      sx={{
                        '&:before': { display: 'none' }, // Enlève la ligne de séparation par défaut
                        borderTop: '1px solid #F1F5F9',
                      }}
                    >
                      <AccordionSummary
                        expandIcon={
                          <ExpandMoreIcon sx={{ color: '#4318FF' }} />
                        }
                        sx={{
                          bgcolor: '#F8FAFC',
                          minHeight: 48,
                          '& .MuiAccordionSummary-content': { my: 1 },
                        }}
                      >
                        <Typography
                          variant="caption"
                          fontWeight={800}
                          color="#4318FF"
                        >
                          CRÉNEAUX RÉSERVÉS ({a.reserved_slots?.length || 0})
                        </Typography>
                      </AccordionSummary>

                      <AccordionDetails
                        sx={{
                          p: 2,
                          bgcolor: '#F8FAFC',
                          maxHeight: 400,
                          overflowY: 'auto',
                        }}
                      >
                        <Stack spacing={1}>
                          {a.reserved_slots?.length > 0 ? (
                            a.reserved_slots.map((slot) => {
                              const style = getSlotStyle(slot.status);

                              return (
                                <Box
                                  key={slot.id_reserved_slot}
                                  sx={{
                                    p: 1.5,
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    bgcolor: '#FFFFFF',
                                    borderRadius: 2,
                                    borderLeft: `4px solid ${style.color}`,
                                    boxShadow: '0px 2px 4px rgba(0,0,0,0.02)',
                                  }}
                                >
                                  {/* TIME */}
                                  <Typography
                                    variant="caption"
                                    fontWeight={700}
                                  >
                                    {new Date(
                                      slot.start_time.replace(' ', 'T')
                                    ).toLocaleTimeString([], {
                                      hour: '2-digit',
                                      minute: '2-digit',
                                    })}
                                    <span
                                      style={{
                                        color: '#A3AED0',
                                        margin: '0 8px',
                                      }}
                                    >
                                      →
                                    </span>
                                    {new Date(
                                      slot.end_time.replace(' ', 'T')
                                    ).toLocaleTimeString([], {
                                      hour: '2-digit',
                                      minute: '2-digit',
                                    })}
                                  </Typography>

                                  {/* STATUS + ACTION */}
                                  <Box
                                    display="flex"
                                    alignItems="center"
                                    gap={1}
                                  >
                                    {/* badge status */}
                                    <Box
                                      sx={{
                                        px: 1,
                                        py: 0.3,
                                        borderRadius: 2,
                                        fontSize: 11,
                                        fontWeight: 700,
                                        bgcolor: style.bg,
                                        color: style.color,
                                        textTransform: 'capitalize',
                                      }}
                                    >
                                      {slot.status}
                                    </Box>

                                    {/* select update */}
                                    <select
                                      value={slot.status}
                                      onChange={(e) =>
                                        updateSlotStatus(
                                          slot.id_reserved_slot,
                                          e.target.value
                                        )
                                      }
                                      style={{
                                        fontSize: 12,
                                        padding: '4px 6px',
                                        borderRadius: 6,
                                        border: '1px solid #E2E8F0',
                                        cursor: 'pointer',
                                        outline: 'none',
                                      }}
                                    >
                                      <option value="available">
                                        Disponible
                                      </option>
                                      <option value="reserved">Réservé</option>
                                      <option value="blocked">Bloqué</option>
                                      <option value="cancelled">Annulé</option>
                                    </select>
                                  </Box>
                                </Box>
                              );
                            })
                          ) : (
                            <Typography
                              variant="caption"
                              color="#A3AED0"
                              sx={{ textAlign: 'center', py: 2 }}
                            >
                              Aucun créneau réservé pour le moment.
                            </Typography>
                          )}
                        </Stack>
                      </AccordionDetails>
                    </Accordion>
                  </Paper>
                </Box>
              ))}
            </Box>

            {/* --- FOOTER --- */}
            <Box sx={{ p: 3, bgcolor: '#FFF', borderTop: '1px solid #F1F5F9' }}>
              <Grid container spacing={2}>
                <Grid item xs={6}></Grid>
                <Grid item xs={6}></Grid>
              </Grid>
            </Box>
          </Box>
        )}
      </Drawer>

      <Dialog
        open={open}
        onClose={() => !loading && setOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '24px', // Un peu moins prononcé pour rester pro
            height: '80vh', // Hauteur fixe pour forcer le scroll interne
            display: 'flex',
            flexDirection: 'row',
            overflow: 'hidden',
          },
        }}
      >
        <Box
          sx={{
            width: '280px',
            bgcolor: '#F9FBFF',
            p: 4,
            borderRight: '1px solid #E2EBF6',
            display: { xs: 'none', md: 'flex' },
            flexDirection: 'column',
          }}
        >
          <Typography variant="h6" fontWeight="800" color="#1B2559" mb={4}>
            Configuration
          </Typography>
          <Stepper
            activeStep={activeStep}
            orientation="vertical"
            sx={{ '& .MuiStepConnector-line': { minHeight: '30px' } }}
          >
            {steps.map((s, i) => (
              <Step key={i}>
                <StepLabel
                  StepIconComponent={() => (
                    <Avatar
                      sx={{
                        width: 42,
                        height: 42,
                        bgcolor:
                          activeStep === i
                            ? '#4318FF'
                            : activeStep > i
                              ? '#05CD99'
                              : '#fff',
                        color: activeStep >= i ? '#fff' : '#A3AED0',
                        border: activeStep < i ? '2px solid #E2EBF6' : 'none',
                        boxShadow:
                          activeStep === i
                            ? '0px 8px 16px rgba(67, 24, 255, 0.25)'
                            : 'none',
                      }}
                    >
                      {activeStep > i ? (
                        <CheckCircle sx={{ fontSize: 22 }} />
                      ) : (
                        s.icon
                      )}
                    </Avatar>
                  )}
                >
                  <Box ml={1}>
                    <Typography
                      variant="subtitle2"
                      fontWeight="800"
                      color={activeStep >= i ? '#1B2559' : '#A3AED0'}
                    >
                      {s.label}
                    </Typography>
                    <Typography variant="caption" color="#A3AED0">
                      {s.desc}
                    </Typography>
                  </Box>
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>

        {/* Main Content */}
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            bgcolor: '#fff',
            px: { xs: 1, md: 2 }, // On élargit les marges latérales (48px sur desktop)
          }}
        >
          {' '}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
            <IconButton
              onClick={() => setOpen(false)}
              sx={{ bgcolor: '#F4F7FE' }}
            >
              <CloseIcon size="small" />
            </IconButton>
          </Box>
          <Box
            sx={{
              flex: 1,
              minHeight: 0,
              overflowY: 'auto', // 🔥 LE POINT CLÉ
              pr: 1,
            }}
          >
            {' '}
            <Typography variant="h5" fontWeight="800" color="#1B2559" mb={1}>
              {steps[activeStep].label}
            </Typography>
            <Typography variant="body2" color="#A3AED0" mb={4}>
              Veuillez créer vos catégorie avant de finaliser vos offres de
              consultations.
            </Typography>
            {activeStep === 0 && (
              <Fade in>
                {/* Le spacing={3} crée un gap automatique de 24px entre chaque enfant direct */}
                <Stack spacing={3} sx={{ mt: 1 }}>
                  <TextField
                    fullWidth
                    label="Nom de l'offre"
                    placeholder="ex: Coaching Performance"
                    value={formData.titre_offre}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        titre_offre: e.target.value,
                      })
                    }
                    sx={inputStyle}
                  />

                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    label="Description complète"
                    placeholder="Détaillez les bénéfices de votre offre..."
                    value={formData.description_offre}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        description_offre: e.target.value,
                      })
                    }
                    sx={inputStyle}
                  />

                  {/* Sélecteur de catégorie en FullWidth avec un peu de marge interne */}
                  <TextField
                    fullWidth
                    select
                    label="Catégorie"
                    value={formData.id_category}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        id_category: e.target.value,
                      })
                    }
                    sx={inputStyle}
                  >
                    {categories.map((c) => (
                      <MenuItem
                        key={c.id_category}
                        value={c.id_category}
                        sx={{ py: 1.5, fontWeight: '600', color: '#1B2559' }}
                      >
                        {c.title_category}
                      </MenuItem>
                    ))}
                    {categories.length === 0 && (
                      <MenuItem disabled>Chargement des catégories...</MenuItem>
                    )}
                  </TextField>

                  <TextField
                    fullWidth
                    type="number"
                    label="Durée (min)"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">min</InputAdornment>
                      ),
                    }}
                    value={formData.duree_offre}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        duree_offre: e.target.value,
                      })
                    }
                    sx={inputStyle}
                  />
                  <TextField
                    fullWidth
                    select
                    label="Type de consultation"
                    value={formData.type_offre}
                    onChange={(e) =>
                      setFormData({ ...formData, type_offre: e.target.value })
                    }
                    sx={inputStyle}
                  >
                    <MenuItem value="chat">Messagerie instantanée</MenuItem>
                    {/*  <MenuItem value="call">Appel téléphonique</MenuItem> */}
                    <MenuItem value="visio_conference">
                      Visioconférence
                    </MenuItem>
                    {/*                     <MenuItem value="emailing">Email</MenuItem>
                     */}{' '}
                  </TextField>
                  {user.role !== 3 && (
                    <TextField
                      fullWidth
                      select
                      label="Intervenant"
                      value={formData.id_intervenant}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          id_intervenant: e.target.value,
                        })
                      }
                      sx={inputStyle}
                    >
                      {intervenants.map((i) => (
                        <MenuItem key={i.id_user} value={i.id_user}>
                          <Stack
                            direction="row"
                            spacing={2}
                            alignItems="center"
                          >
                            <Avatar
                              src={`${process.env.REACT_APP_API_URL}/storage/workshop/${i.photo_user}`}
                              alt={`${i.nom_user} ${i.prenom_user}`}
                              sx={{ width: 32, height: 32 }}
                            />
                            <Typography>
                              {i.nom_user} {i.prenom_user}
                            </Typography>
                          </Stack>
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                </Stack>
              </Fade>
            )}
            {/* ... (Reste des étapes identique au code précédent) ... */}
            {activeStep === 1 && (
              <Fade in>
                <Stack spacing={3}>
                  {/* Champ Prix */}
                  <TextField
                    fullWidth
                    type="number"
                    label="Prix de la prestation"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">€</InputAdornment>
                      ),
                    }}
                    value={formData.prix_offre}
                    onChange={(e) =>
                      setFormData({ ...formData, prix_offre: e.target.value })
                    }
                    sx={inputStyle}
                  />

                  <Box
                    sx={{
                      p: 4,
                      bgcolor: '#F9FBFF',
                      borderRadius: '24px',
                      border: '1px solid #E2EBF6',
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      fontWeight="800"
                      color="#1B2559"
                      mb={3}
                    >
                      Configuration & Droits d'accès
                    </Typography>

                    <Stack spacing={2.5}>
                      {/* 1. STATUS DE L'OFFRE */}
                      <FormControlLabel
                        control={
                          <Switch
                            sx={{
                              '& .Mui-checked': {
                                color: '#05CD99 !important',
                              },
                              '& .Mui-checked + .MuiSwitch-track': {
                                backgroundColor: '#05CD99 !important',
                              },
                            }}
                            checked={formData.status}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                status: e.target.checked,
                              })
                            }
                          />
                        }
                        label={
                          <Box sx={{ ml: 1 }}>
                            <Typography fontWeight="700" color="#1B2559">
                              {formData.status
                                ? 'Offre Activée'
                                : 'Offre Désactivée'}
                            </Typography>
                            <Typography variant="caption" color="#A3AED0">
                              Rendre cette prestation visible et réservable.
                            </Typography>
                          </Box>
                        }
                      />

                      <Divider sx={{ borderStyle: 'dashed' }} />

                      {/* 2. PRIVILÈGE ABONNÉ */}
                      <FormControlLabel
                        control={
                          <Switch
                            sx={{
                              '& .Mui-checked': {
                                color: '#05CD99 !important',
                              },
                              '& .Mui-checked + .MuiSwitch-track': {
                                backgroundColor: '#05CD99 !important',
                              },
                            }}
                            checked={formData.is_accessible_participant}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                is_accessible_participant: e.target.checked,
                              })
                            }
                          />
                        }
                        label={
                          <Box sx={{ ml: 1 }}>
                            <Typography fontWeight="700" color="#1B2559">
                              {formData.is_accessible_participant
                                ? "Inclus dans l'abonnement"
                                : 'Hors abonnement'}
                            </Typography>
                            <Typography variant="caption" color="#A3AED0">
                              {formData.is_accessible_participant
                                ? 'Les abonnés accèdent à cette offre gratuitement.'
                                : 'Tout le monde doit payer pour cette prestation.'}
                            </Typography>
                          </Box>
                        }
                      />

                      <Divider sx={{ borderStyle: 'dashed' }} />

                      {/* 3. PAIEMENT À LA RÉSERVATION */}
                      <FormControlLabel
                        control={
                          <Switch
                            sx={{
                              '& .Mui-checked': {
                                color: '#05CD99 !important',
                              },
                              '& .Mui-checked + .MuiSwitch-track': {
                                backgroundColor: '#05CD99 !important',
                              },
                            }}
                            checked={formData.is_paid_offre}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                is_paid_offre: e.target.checked,
                              })
                            }
                          />
                        }
                        label={
                          <Box sx={{ ml: 1 }}>
                            <Typography fontWeight="700" color="#1B2559">
                              Paiement à la réservation
                            </Typography>
                            <Typography variant="caption" color="#A3AED0">
                              Exiger le règlement immédiat lors de la
                              réservation.
                            </Typography>
                          </Box>
                        }
                      />
                    </Stack>
                  </Box>
                </Stack>
              </Fade>
            )}
            {/* Étape 2 et 3 omises ici pour la brièveté mais gardées dans ton projet */}
            {activeStep === 2 && (
              <Fade in>
                <Stack spacing={4}>
                  <Box>
                    <Typography variant="body2" color="#A3AED0" mb={4}>
                      Définissez les dates limites durant lesquelles cette offre
                      sera proposée à la réservation.
                    </Typography>

                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          type="date"
                          label="Date de début"
                          InputLabelProps={{ shrink: true }}
                          // Ajout de la limite minimale ici
                          inputProps={{ min: today }}
                          value={formData.date_debut_dispo}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              date_debut_dispo: e.target.value,
                            })
                          }
                          sx={inputStyle}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          type="date"
                          label="Date de fin"
                          InputLabelProps={{ shrink: true }}
                          value={formData.date_fin_dispo}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              date_fin_dispo: e.target.value,
                            })
                          }
                          sx={inputStyle}
                        />
                      </Grid>
                    </Grid>

                    {/* Affichage du message uniquement si les dates sont remplies */}
                    {formData.date_debut_dispo && formData.date_fin_dispo && (
                      <Fade in>
                        <Box
                          sx={{
                            mt: 2,
                            p: 2,
                            bgcolor: '#E6FFFA',
                            borderRadius: '16px',
                            border: '1px solid #05CD99',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1.5,
                          }}
                        >
                          <CheckCircle
                            sx={{ color: '#05CD99', fontSize: 20 }}
                          />
                          <Typography
                            variant="caption"
                            color="#065F46"
                            fontWeight="700"
                          >
                            La disponibilité est activée directement depuis
                            l'offre :
                            <span
                              style={{ color: '#4318FF', marginLeft: '5px' }}
                            >
                              {formData.titre_offre || 'Sans titre'}
                            </span>
                          </Typography>
                        </Box>
                      </Fade>
                    )}
                    <FormControlLabel
                      sx={{ mt: 4 }}
                      control={
                        <Switch
                          checked={formData.is_deplacement_possible || false}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              is_deplacement_possible: e.target.checked,
                            })
                          }
                          color="primary"
                        />
                      }
                      label="Déplacement possible (chez le client)"
                    />
                    <Divider sx={{ my: 2 }} />

                    <FormControl fullWidth sx={inputStyle}>
                      <InputLabel>Format de l’offre</InputLabel>
                      <Select
                        value={formData.format_offre || ''}
                        label="Format de l’offre"
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            format_offre: e.target.value,
                          })
                        }
                      >
                        <MenuItem value="presentiel">Présentiel</MenuItem>
                        <MenuItem value="zoom">En ligne (Zoom)</MenuItem>
                        <MenuItem value="hybride">Hybride</MenuItem>
                      </Select>
                    </FormControl>
                    {(formData.format_offre === 'presentiel' ||
                      formData.format_offre === 'hybride') && (
                      <Fade in>
                        <Box mt={3}>
                          <Typography
                            variant="subtitle2"
                            fontWeight="700"
                            mb={2}
                          >
                            Localisation de l’offre
                          </Typography>

                          <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                              <TextField
                                fullWidth
                                label="Adresse"
                                value={formData.address_ws || ''}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    address_ws: e.target.value,
                                  })
                                }
                                sx={inputStyle}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <TextField
                                fullWidth
                                label="Ville"
                                value={formData.city_ws || ''}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    city_ws: e.target.value,
                                  })
                                }
                                sx={inputStyle}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <TextField
                                fullWidth
                                label="Code postal"
                                value={formData.postal_code_ws || ''}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    postal_code_ws: e.target.value,
                                  })
                                }
                                sx={inputStyle}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <TextField
                                fullWidth
                                label="Pays"
                                value={formData.country_ws || ''}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    country_ws: e.target.value,
                                  })
                                }
                                sx={inputStyle}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <TextField
                                fullWidth
                                label="Latitude"
                                value={formData.lat_ws || ''}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    lat_ws: e.target.value,
                                  })
                                }
                                sx={inputStyle}
                              />
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <TextField
                                fullWidth
                                label="Longitude"
                                value={formData.lng_ws || ''}
                                onChange={(e) =>
                                  setFormData({
                                    ...formData,
                                    lng_ws: e.target.value,
                                  })
                                }
                                sx={inputStyle}
                              />
                            </Grid>{' '}
                            <TextField
                              fullWidth
                              label="Note de localisation (optionnel)"
                              multiline
                              rows={2}
                              value={formData.location_note_ws || ''}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  location_note_ws: e.target.value,
                                })
                              }
                              sx={inputStyle}
                            />
                          </Grid>
                        </Box>
                      </Fade>
                    )}
                  </Box>
                </Stack>
              </Fade>
            )}
            {activeStep === 3 && (
              <Fade in>
                <Stack spacing={3}>
                  <Box>
                    <Typography variant="body2" color="#A3AED0" mb={3}>
                      Configurez les jours de fermeture et les tranches horaires
                      de l'offre.
                    </Typography>

                    {/* --- SECTION HORAIRES (MATIN / APREM) --- */}
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <Box
                          sx={{
                            p: 2,
                            borderRadius: '20px',
                            bgcolor: '#F9FBFF',
                            border: '1px solid #E2EBF6',
                          }}
                        >
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                            mb={2}
                          >
                            <Avatar
                              sx={{
                                width: 28,
                                height: 28,
                                bgcolor: '#4318FF',
                              }}
                            >
                              1
                            </Avatar>
                            <Typography variant="subtitle2" fontWeight="800">
                              Plage du Matin
                            </Typography>
                          </Stack>
                          <Stack spacing={2}>
                            <TextField
                              fullWidth
                              type="time"
                              label="Début"
                              InputLabelProps={{ shrink: true }}
                              value={formData.plage_horaire_matin_debut}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  plage_horaire_matin_debut: e.target.value,
                                })
                              }
                              sx={inputStyle}
                            />
                            <TextField
                              fullWidth
                              type="time"
                              label="Fin"
                              InputLabelProps={{ shrink: true }}
                              value={formData.plage_horaire_matin_fin}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  plage_horaire_matin_fin: e.target.value,
                                })
                              }
                              sx={inputStyle}
                            />
                          </Stack>
                        </Box>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Box
                          sx={{
                            p: 2,
                            borderRadius: '20px',
                            bgcolor: '#F9FBFF',
                            border: '1px solid #E2EBF6',
                          }}
                        >
                          <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                            mb={2}
                          >
                            <Avatar
                              sx={{
                                width: 28,
                                height: 28,
                                bgcolor: '#4318FF',
                              }}
                            >
                              2
                            </Avatar>
                            <Typography variant="subtitle2" fontWeight="800">
                              Plage Après-midi
                            </Typography>
                          </Stack>
                          <Stack spacing={2}>
                            <TextField
                              fullWidth
                              type="time"
                              label="Début"
                              InputLabelProps={{ shrink: true }}
                              value={formData.plage_horaire_aprem_debut}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  plage_horaire_aprem_debut: e.target.value,
                                })
                              }
                              sx={inputStyle}
                            />
                            <TextField
                              fullWidth
                              type="time"
                              label="Fin"
                              InputLabelProps={{ shrink: true }}
                              value={formData.plage_horaire_aprem_fin}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  plage_horaire_aprem_fin: e.target.value,
                                })
                              }
                              sx={inputStyle}
                            />
                          </Stack>
                        </Box>
                      </Grid>
                    </Grid>

                    {/* --- SECTION PAUSE --- */}
                    <Box sx={{ mt: 3 }}>
                      <TextField
                        fullWidth
                        type="number"
                        label="Temps de pause (Entre chaque séance)"
                        value={formData.duree_pause}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            duree_pause: e.target.value,
                          })
                        }
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              minutes
                            </InputAdornment>
                          ),
                        }}
                        sx={inputStyle}
                      />
                    </Box>

                    {/* --- SECTION JOURS DE REPOS (APRÈS PAUSE ✅) --- */}
                    <Box
                      sx={{
                        p: 2.5,
                        mt: 3,
                        borderRadius: '20px',
                        border: '1px solid #E2EBF6',
                        bgcolor: '#FFF',
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        fontWeight="800"
                        color="#1B2559"
                        mb={2}
                      >
                        Jours de repos (Sélectionnez les jours fermés)
                      </Typography>

                      <Stack
                        direction="row"
                        spacing={1}
                        flexWrap="wrap"
                        useFlexGap
                        gap={1.5}
                      >
                        {DAYS_OF_WEEK.map((day) => {
                          const isSelected = formData.jours_off.includes(day);

                          return (
                            <Chip
                              key={day}
                              label={day.charAt(0).toUpperCase() + day.slice(1)}
                              onClick={() => toggleJourOff(day)}
                              icon={
                                isSelected ? (
                                  <CloseIcon
                                    sx={{ fontSize: 16, color: '#FFF' }}
                                  />
                                ) : null
                              }
                              sx={{
                                borderRadius: '12px',
                                fontWeight: '700',
                                px: 1,
                                py: 2.5,
                                bgcolor: isSelected ? '#FF5B5B' : '#F4F7FE',
                                color: isSelected ? '#FFF' : '#A3AED0',
                                border: isSelected
                                  ? 'none'
                                  : '1px solid #E2EBF6',
                                '&:hover': {
                                  bgcolor: isSelected ? '#FF4444' : '#E2EBF6',
                                },
                              }}
                            />
                          );
                        })}
                      </Stack>
                    </Box>
                  </Box>
                </Stack>
              </Fade>
            )}
          </Box>
          <DialogActions
            sx={{
              p: 3,
              borderTop: '1px solid #E2EBF6',
              bgcolor: '#fff',
              justifyContent: 'space-between',
            }}
          >
            <Button
              onClick={
                activeStep === 0
                  ? () => setOpen(false)
                  : () => setActiveStep(activeStep - 1)
              }
              sx={{
                color: '#718096',
                fontWeight: '800',
                textTransform: 'none',
              }}
            >
              {activeStep === 0 ? 'Annuler' : 'Revenir en arrière'}
            </Button>
            <Button
              variant="contained"
              disabled={!isStepValid() || loading}
              onClick={
                activeStep === steps.length - 1
                  ? handleSubmit
                  : () => setActiveStep(activeStep + 1)
              }
              sx={{
                bgcolor: '#4318FF',
                borderRadius: '16px',
                px: 6,
                py: 1.5,
                fontWeight: '800',
                textTransform: 'none',
                boxShadow: '0px 10px 20px rgba(67, 24, 255, 0.2)',
              }}
            >
              {loading
                ? 'Traitement...'
                : activeStep === steps.length - 1
                  ? isEditMode
                    ? 'Mettre à jour'
                    : 'Publier maintenant'
                  : 'Étape suivante'}{' '}
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </Box>
  );
};

export default Offres;
